import React from "react"
import {
    Box,
    componentStyles,
    DynamicChart,
    Text,
    useColors,
    useTheme,
    VerticalStack,
} from "@mallardbay/lib-react-components"

import type { AssistantChartPresentation } from "~components/outfitter-assistant/assistant-chart-tool.helpers"

interface Props {
    readonly presentation: AssistantChartPresentation
}

export default function AssistantChartCard({ presentation }: Props) {
    const styles = useStyles()

    return (
        <Box style={styles.root}>
            <VerticalStack style={styles.header}>
                <Text style={styles.title}>{presentation.title}</Text>
                {presentation.description ? (
                    <Text style={styles.description}>
                        {presentation.description}
                    </Text>
                ) : null}
            </VerticalStack>
            <DynamicChart chart={presentation.chart} height={240} />
        </Box>
    )
}

function useStyles() {
    const colors = useColors()
    const theme = useTheme()

    return componentStyles({
        root: {
            width: "100%",
            gap: 3,
            padding: 3,
            borderRadius: theme.radii.lg,
            backgroundColor: colors.bgSecondary,
        },
        header: {
            alignItems: "stretch",
            gap: 1,
        },
        title: {
            fontWeight: theme.fontWeights.semibold,
            color: colors.text,
        },
        description: {
            color: colors.secondaryText,
            fontSize: theme.fontSizes.sm,
        },
    })
}
